// extracted by mini-css-extract-plugin
module.exports = {"Grid":"grid-module--Grid--2NzKS"};